/* eslint-disable max-lines-per-function */
import React, { useCallback } from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import CssBaseline from '@material-ui/core/CssBaseline';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import { Tooltip } from '@material-ui/core';
import Dimmer from '+/Dimmer';
import EnhancedTable from '../orders/components/EnhancedTable';
import { useDeleteAmenityTypes, useAmenityTypes } from '../../api/amenity-types';
import { useDeleteAmenityTags, useAmenityTags } from '../../api/amenity-tags';
import { getState } from '../../store';
import FormTags from './FormTags';
import FormTypes from './FormTypes';
import orderBy from 'lodash/orderBy';

const Config = () => {

    const { data: amenity_tags, isFetchingAmenityTags, isErrorAmenityTags } = useAmenityTags();
    const { data: amenity_types, isFetching, isError } = useAmenityTypes();

    const { mutate: deleteAmenityTags } = useDeleteAmenityTags();
    const { mutate: deleteAmenityTypes } = useDeleteAmenityTypes();

    const [modalTagsOpen, setModalTagsOpen] = React.useState(false);
    const [modalNamesOpen, setModalNamesOpen] = React.useState(false);
    const [currentTag, setcurrentTag] = React.useState(null);
    const [currentName, setcurrentName] = React.useState(null);
    const { role } = getState().auth;

    const openModalTags = useCallback(order => {

        setcurrentTag(order || {});
        setModalTagsOpen(true);
    }, [setcurrentTag, setModalTagsOpen]);

    const closeModalTags = useCallback(() => {

        setcurrentTag({});
        setModalTagsOpen(false);
    }, [setcurrentTag, setModalTagsOpen]);

    const openModalNames = useCallback(order => {

        setcurrentName(order || {});
        setModalNamesOpen(true);
    }, [setcurrentName, setModalNamesOpen]);

    const closeModalNames = useCallback(() => {

        setcurrentName({});
        setModalNamesOpen(false);
    }, [setcurrentName, setModalNamesOpen]);

    const style_Modal = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4
    };

    const style_rows = {
        paddingLeft: '8px',
        paddingRight: '0px',
        paddingTop: '0px',
        paddingBottom: '0px',
        marginLeft: '1px',
        width: '100%'
    };

    const columnsTags = [
        {
            Header: 'Tag Name',
            accessor: 'name'
        },
        {
            Header: () => '',
            id: 'actions',
            Cell: ({ row }) => {


                const SelectIcon = icon => (

                    <Tooltip title='Delete'>
                        <IconButton onClick={() => {
                            deleteAmenityTags({
                                tag: row.values.name

                            });

                            return;

                        }}>
                            <DeleteIcon />
                        </IconButton>
                    </Tooltip>);

                return (

                    <div style={{
                        display: 'flex',
                        justifyContent: 'center'
                    }}>
                        <div>
                            <Tooltip title='Edit' onClick={() => {
                                openModalTags(row.original);
                            }}>
                                <IconButton>
                                    <EditIcon />
                                </IconButton>
                            </Tooltip>
                        </div>

                        <div>
                            { SelectIcon(row.original.icon) }
                        </div>

                    </div>
                );
            }
        }
    ];

    const columnsNames = [
        {
            Header: 'Tag Name',
            accessor: 'tag'
        },
        {
            Header: 'Type Name',
            accessor: 'type',
            minWidth: 750
        },
        {
            Header: () => '',
            id: 'actions',
            Cell: ({ row }) => {


                const SelectIcon = icon => (

                    <Tooltip title='Delete'>
                        <IconButton onClick={() => {

                            deleteAmenityTypes({
                                tag: row.values.tag,
                                type: row.values.type
                            });
                        }}>
                            <DeleteIcon />
                        </IconButton>
                    </Tooltip>);

                return (

                    <div style={{
                        display: 'flex',
                        justifyContent: 'center'
                    }}>
                        <div>
                            <Tooltip title='Edit' onClick={() => {
                                openModalNames(row.original);
                            }}>
                                <IconButton>
                                    <EditIcon />
                                </IconButton>
                            </Tooltip>
                        </div>

                        <div>
                            { SelectIcon(row.original.icon) }
                        </div>

                    </div>
                );
            }
        }
    ];

    if (isFetching || isFetchingAmenityTags) return <Dimmer />;

    if (isError || isErrorAmenityTags) {
        return 'Internal Error - Contact Technical Support';
    }


    const amenity_tags_ordered = orderBy(amenity_tags, ['name']);
    const amenity_types_ordered = orderBy(amenity_types.flat(), ['tag']);


    return (
        <div>
            <h1 style={{ color: '#002144' }}>Orders Configuration</h1>
            <br></br>

            {/* 1th table */}
            <h4 style={{ color: '#002144' }}>TAGS</h4>
            <div style={{
                marginTop: 20,
                borderStyle: 'groove',
                borderWidth: '1px'

            }}>

                <CssBaseline />
                <EnhancedTable
                    style_rows = {style_rows}
                    columns={columnsTags}
                    data={amenity_tags_ordered}
                    setModalTagsOpen={() => openModalTags()}
                    setModalNamesOpen={() => openModalNames()}
                />
            </div>

            <br></br>
            {/* 2th table */}
            <h4 style={{ color: '#002144' }}>TYPES</h4>
            <div style={{
                marginTop: 20,
                borderStyle: 'groove',
                borderWidth: '1px'

            }}>

                <CssBaseline />
                <EnhancedTable
                    style_rows = {style_rows}
                    columns={columnsNames}
                    data={amenity_types_ordered}
                    setModalNamesOpen={() => openModalNames()}
                />
            </div>

            <Modal
                open={modalTagsOpen}
                // onClose={handleClose}
                aria-labelledby='modal-modal-title'
                aria-describedby='modal-modal-description'
            >
                <Box sx={style_Modal}>
                    <FormTags setModalTagsOpen={() => closeModalTags()}
                        initialValues={currentTag}
                        role={role}
                    />
                </Box>
            </Modal>

            <Modal
                open={modalNamesOpen}
                // onClose={handleClose}
                aria-labelledby='modal-modal-title'
                aria-describedby='modal-modal-description'
            >
                <Box sx={style_Modal}>
                    <FormTypes setModalNamesOpen={() => closeModalNames()}
                        initialValues={currentName}
                        role={role}
                        amenity_tags_ordered = {amenity_tags_ordered}
                        amenity_types_ordered = {amenity_types_ordered}
                    />
                </Box>
            </Modal>


        </div>
    );
};

export default Config;
